import type { ContentRecord } from '@/lib/content-types';

// A megadott nyilvános eredménylistákból ellenőrzött adatok.
// Az adminban már mentett mezők (az üresre állítottak is) elsőbbséget kapnak.
export const athleteProfiles: { aliases: string[]; record: ContentRecord }[] = [{
  aliases: ['Zs. Somló Zsuzsanna', 'Zs. Somló Zsuzsanna Panka'],
  record: {
    id: 'athlete-zs-somlo-zsuzsanna', kind: 'athlete', title: 'Zs. Somló Zsuzsanna',
    status: 'published', sortOrder: 3, isDefault: true,
    data: {
      initials: 'ZS', category: 'C1 női ifjúsági', focus: 'síkvízi és maraton kenu', color: 'blue', image: '', alt: '', athleteProfileId: 'athlete-zs-somlo-zsuzsanna',
      resultsUrl: 'https://results.kajakkenusport.hu/faces/pages/sportolo.xhtml?azon=20350',
      achievementSummary: [
        'Ifjúsági világbajnokság · 7. hely: 1×',
        'Ifjúsági Európa-bajnokság · 2. hely: 1×',
        'Ifjúsági magyar bajnokság · 1. hely: 1×; 3. hely: 2×',
      ],
      highlights: [
        '2026 – Ifjúsági Európa-bajnokság, C4 mix 500 m, 2. hely.',
        '2026 – Ifjúsági világbajnokság, C4 női 500 m, 7. hely.',
        '2026 – Ifjúsági magyar bajnokság, C1 női 1000 m, 3. hely.',
      ],
    },
  },
}, {
  aliases: ['Csomor Balázs'],
  record: {
    id: 'athlete-csomor-balazs', kind: 'athlete', title: 'Csomor Balázs',
    status: 'published', sortOrder: 4, isDefault: true,
    data: {
      initials: 'CB', category: 'K1 férfi ifjúsági', focus: 'síkvízi és maraton kajak', color: 'navy', image: '', alt: '', athleteProfileId: 'athlete-csomor-balazs',
      resultsUrl: 'https://results.kajakkenusport.hu/faces/pages/sportolo.xhtml?azon=20477',
      achievementSummary: [
        'Síkvízi magyar bajnokság (korosztályos) · 1. hely: 2×; 2. hely: 2×; 3. hely: 3×',
        'Maraton magyar bajnokság (korosztályos) · 1. hely: 1×; 2. hely: 1×; 3. hely: 1×',
        'Vidék Bajnokság (korosztályos) · 1. hely: 1×; 2. hely: 6×; 3. hely: 4×',
      ],
      highlights: [
        '2024 – Serdülő magyar bajnokság, K4 férfi 1000 m, 2. hely.',
        '2023 – Maraton magyar bajnokság, K2 férfi serdülő U15 15 km, 1. hely.',
        '2026 – Maraton magyar bajnokság, K1 férfi ifjúsági 21 km, 8. hely.',
        '2026 – Ifjúsági magyar bajnokság, K1 férfi 1000 m, B döntő 3. hely.',
      ],
    },
  },
}, {
  aliases: ['Laczó Dániel'],
  record: {
    id: 'athlete-laczo-daniel', kind: 'athlete', title: 'Laczó Dániel',
    status: 'published', sortOrder: 0, isDefault: true,
    data: {
      initials: 'LD', category: 'C1 férfi felnőtt', focus: 'síkvízi és maraton kenu', color: 'blue', image: '', alt: '', athleteProfileId: 'athlete-laczo-daniel',
      resultsUrl: 'https://results.kajakkenusport.hu/faces/pages/sportolo.xhtml?azon=12475',
      achievementSummary: [
        'Maraton világbajnokság (U23) · 1. hely: 1×; 3. hely: 2×',
        'Maraton világbajnokság (felnőtt) · 3. hely: 1×',
        'Maraton világbajnokság (ifjúsági) · 3. hely: 1×',
        'Egyetemi világbajnokság · 3. hely: 1×',
        'Maraton Európa-bajnokság (felnőtt) · 2. hely: 1×; 3. hely: 3×',
        'Maraton Európa-bajnokság (U23) · 2. hely: 1×',
        'Maraton magyar bajnokság (felnőtt) · 1. hely: 4×; 2. hely: 6×; 3. hely: 3×',
        'Síkvízi magyar bajnokság (felnőtt) · 2. hely: 1×; 3. hely: 2×',
      ],
      highlights: [
        '2021 – U23 maraton világbajnokság, C1 férfi 22,6 km, 1. hely.',
        '2019 – Felnőtt maraton világbajnokság, C2 férfi 26 km, 3. hely.',
        '2026 – Felnőtt maraton magyar bajnokság, C2 férfi 22 km, 1. hely.',
      ],
    },
  },
}, {
  aliases: ['Kruzslicz Réka', 'Kruzslicz Réka Renáta'],
  record: {
    id: 'athlete-kruzslicz-reka', kind: 'athlete', title: 'Kruzslicz Réka',
    status: 'published', sortOrder: 5, isDefault: true,
    data: {
      initials: 'KR', category: 'K1 női masters', focus: 'síkvízi és maraton kajak', color: 'red', image: '', alt: '', athleteProfileId: 'athlete-kruzslicz-reka',
      resultsUrl: 'https://results.kajakkenusport.hu/faces/pages/sportolo.xhtml?azon=1736',
      achievementSummary: [
        '2026 · Maraton masters Európa-bajnokság (45–49 év) · 2. hely: 1×',
      ],
      highlights: [
        '2026 – Maraton masters Európa-bajnokság, Pitești, K1 női 45–49 év, 2. hely.',
      ],
    },
  },
}];

function normalizedName(value: string): string {
  return value.toLowerCase().replace(/[.\s]+/gu, '');
}

export function withAthleteProfiles(records: ContentRecord[]): ContentRecord[] {
  const next = [...records];
  for (const profile of athleteProfiles) {
    const names = profile.aliases.map(normalizedName);
    let found = false;
    for (let index = 0; index < next.length; index++) {
      const current = next[index];
      if (current.kind !== 'athlete' || (current.id !== profile.record.id && current.data.athleteProfileId !== profile.record.id && !names.includes(normalizedName(current.title)))) continue;
      found = true;
      const data = { ...current.data };
      const firstProfile = !data.athleteProfileId;
      for (const key of ['resultsUrl', 'achievementSummary']) {
        const blank = data[key] === '' || (Array.isArray(data[key]) && data[key].length === 0);
        if (!Object.prototype.hasOwnProperty.call(data, key) || (firstProfile && blank)) data[key] = profile.record.data[key];
      }
      data.athleteProfileId = profile.record.id;
      next[index] = { ...current, data };
    }
    if (!found) next.push({ ...profile.record, data: { ...profile.record.data } });
  }
  return next;
}

export function externalResultsUrl(value: string): string {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}
